import {
  InputFieldConfig,
  DerivedEventLegacy,
  type ActiveCohortBuilderItemLegacy,
  SimpleEventLegacy,
} from '@verantos-dev/types-cohorts';

import { addOrMutateDerivedFilters, reduceDerivedConfigMap } from '../utils/derivedEventUtils';
import { DERIVED_EVENT_FILTER_KEYS } from '../utils/filterTypes';

export const addDerivedEvent = (
  derivedEvent: ActiveCohortBuilderItemLegacy,
  simpleEvents: SimpleEventLegacy[],
  derivedEvents: DerivedEventLegacy[]
): ActiveCohortBuilderItemLegacy => {
  const { eventFilters, uniquenessFilters, temporalConstraints } =
    addOrMutateDerivedFilters(derivedEvent);
  const eventFilterNames = eventFilters.map((eventFilter) => eventFilter.eventName.value || '');

  // build the configMap for all filters
  const allConfigMaps = DERIVED_EVENT_FILTER_KEYS.reduce(
    (acc, key) =>
      reduceDerivedConfigMap(acc, key, {
        derivedEvent,
        eventFilters,
        simpleEvents,
        derivedEvents,
        eventFilterNames,
      }),
    {} as Record<string, InputFieldConfig>
  );

  return {
    ...derivedEvent,
    inputFieldConfigMap: {
      ...derivedEvent.inputFieldConfigMap,
      ...allConfigMaps,
    },
  };
};
